import React, {ReactElement} from "react";

import Icon from "../icon/Icon";
import LoadingIcon from "/src/svg/loading.svg";

import {css} from "/src/utils/utils";

import * as styles from "./spinner-loader.module.scss";

interface SpinnerLoaderProps {
  classes?: string;
}

const SpinnerLoader = (props: SpinnerLoaderProps): ReactElement => {
  const {classes} = props;
  return (
    <Icon
      classes={css(styles.spinnerLoader, classes!)}
      svg={LoadingIcon}
      role="presentation"
    />
  );
};

export default SpinnerLoader;
